import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import ToolPage from "@/pages/ToolPage";
import { api } from "@/lib/api";

function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    const sid = match[1];
    api.post("/auth/session", { session_id: sid })
      .then(() => { window.location.hash = ""; navigate("/"); })
      .catch(() => navigate("/"));
  }, [navigate]);
  return <div className="pt-40 text-center text-muted-foreground">Signing you in…</div>;
}

function Shell() {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const onLogout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("Logout failed:", err); }
    setUser(null);
  };

  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Header user={user} onLogout={onLogout} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tool/:toolId" element={<ToolPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
